<template>
  <button
    :class="['text-button']"
    @click="handleClick"
    :title="title"
    :aria-label="title"
  >
    <span class="text-button__label">{{ title || 'lala' }}</span>
    <span v-if="hasIcon" class="text-button__sep">|</span>
    <component
      v-if="hasIcon"
      :is="iconComponent"
      :class="['text-button__icon']"
    />
  </button>
</template>

<script>
import './TextButton.css';
import IconSend from '../icons/IconSend.vue';
import IconClose from '../icons/IconClose.vue';
import IconSave from '../icons/IconSave.vue';
import IconArrowLeft from '../icons/IconArrowLeft.vue';

const ALLOWED = ['send', 'next', 'close', 'save'];

export default {
  name: 'TextButton',
  components: {
    IconSend,
    IconClose,
    IconSave,
    IconArrowLeft
  },
  props: {
    icon: {
      type: String,
      default: null,
      validator(value) {
        return value == null || ALLOWED.includes(value);
      }
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    hasIcon() {
      return !!this.icon;
    },
    iconComponent() {
      if (!this.icon) return null;
      switch (this.icon) {
        case 'send':
          return 'IconSend';
        case 'close':
          return 'IconClose';
        case 'save':
          return 'IconSave';
        case 'next':
          return 'IconArrowLeft';
        default:
          return null;
      }
    }
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    }
  }
};
</script>